import { store } from '@redux/store';
import { articleSearchResultsActions } from 'features/articleSearchResultsFacets';
import typeahead from 'features/articleSearchBox';

const updateSearchTerm = function(searchTerm) {
  store.dispatch(articleSearchResultsActions.updateSearchTermParameter(searchTerm));
};

const submitEventObserver$ = typeahead.getSubmitEventObserver();
submitEventObserver$.subscribe((searchTerm) =>{
  typeahead.clearSuggestions();
  typeahead.closeErrorMessage();
  updateSearchTerm(searchTerm);
});

export default typeahead;